import React from "react";
import { NumericFormat } from "react-number-format";

const TotalAmount = ({
  selectedFilter,
  totalAmountAll,
  totalAmountToday,
  totalAmountWeek,
  totalAmountMonth,
  selectedCurrency,
}) => {
  return (
    <div className="noSpace currencyIcons">
      {selectedFilter === "all" && (
        <span>
          <NumericFormat
            value={totalAmountAll}
            displayType={"text"}
            thousandsGroupStyle="lakh"
            thousandSeparator=","
            prefix={selectedCurrency.label}
          />
        </span>
      )}
      {selectedFilter === "today" && (
        <span>
          <NumericFormat
            value={totalAmountToday}
            displayType={"text"}
            thousandsGroupStyle="lakh"
            thousandSeparator=","
            prefix={selectedCurrency.label}
          />
        </span>
      )}
      {selectedFilter === "currentWeek" && (
        <span>
          {/* Total Expenses (Week):{" "} */}
          <NumericFormat
            value={totalAmountWeek}
            displayType={"text"}
            thousandsGroupStyle="lakh"
            thousandSeparator=","
            prefix={selectedCurrency.label}
          />
        </span>
      )}
      {selectedFilter === "currentMonth" && (
        <span>
          <NumericFormat
            value={totalAmountMonth}
            displayType={"text"}
            thousandsGroupStyle="lakh"
            thousandSeparator=","
            prefix={selectedCurrency.label}
          />
        </span>
      )}
    </div>
  );
};

export default TotalAmount;
